import Icon from "@chakra-ui/icon";
import React from "react";

export const ClockIcon = () => (
  <Icon viewBox="0 0 10 11" color="#A0A0A0" fill="transparent" mr="6px">
    <g clipPath="url(#clip0)">
      <path
        d="M4.99992 9.20602C7.30111 9.20602 9.16659 7.34054 9.16659 5.03935C9.16659 2.73816 7.30111 0.872681 4.99992 0.872681C2.69873 0.872681 0.833252 2.73816 0.833252 5.03935C0.833252 7.34054 2.69873 9.20602 4.99992 9.20602Z"
        stroke="#A0A0A0"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M5 2.53931V5.03931L6.66667 5.87264"
        stroke="#A0A0A0"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </g>
    <defs>
      <clipPath id="clip0">
        <rect
          width="10"
          height="10"
          fill="white"
          transform="translate(0 0.0393066)"
        />
      </clipPath>
    </defs>
  </Icon>
);
